<template>
  <div class="m-news-page">
    <sticky-bar :anchors="anchors"></sticky-bar>

    <div class="selector-date">
      <button v-for="(item, index) in conds"
              :key="index"
              @click="selectYear(item.year)"
              :class="{'active': selected === item.year}">
        {{item.year}}年
      </button>
    </div>

    <router-view/>
  </div>
</template>

<script>
  import StickyBar from '../components/stickyBar.vue'
  import Bus from '../assets/js/Bus'
  import fetch from '../server/index';

  export default {
    data () {
      return {
        anchors: [{
          title: '一维新闻',
          name: 'mNewsList',
//          params: {type: 'bio'},
          icon: null
        }],
        conds: [],
        selected: 0
      }
    },
    watch: {
      selected () {
//        判断路径
        if (this.$route.name === 'NewsDetail') {
          this.$router.push({name: 'NewsList'});
        }
        this.hasMore = true;
        Bus.$emit('getList', this.selected);
      },
      '$route' (to) {
        let self = this;

        if (to.name === 'mNewsList') {
          setTimeout(function () {
            Bus.$emit('getList', self.selected, 1);
          }, 10);
        }
        if (to.name === 'mNewsDetail') {
          Bus.$emit('getDetail');
        }
      }
    },
    methods: {
//      获取年份可选数据
      getConditions () {
        fetch('/api/policyInfo/year').then(res => {
          this.conds = res
          this.selected = res[res.length - 1].year
        }, err => {
          console.log(err)
        }).catch(e => {})
      },
      selectYear (y) {
        this.selected = y;
      }
    },
    components: {
      StickyBar
    },
    created () {
      this.getConditions();
    }
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .m-news-page {
    $theme-color: #00ccff;
    background: #ffffff;
    .sticky-bar{
      text-align: center;
    }

    .selector-date{
      @include c-wrap();
      height: 1.20rem;
      padding-top: .28rem;
      padding-bottom: .28rem;
      button{
        height: .65rem;
        line-height: .65rem;
        background: transparent;
        border: 0;
        color: #7a7a7a;
        font-size: .32rem;
        padding-left: .38rem;
        padding-right: .38rem;
        border-radius: .04rem;

        margin-right: .13rem;
        &.active{
          font-weight: bold;
          color: #fff;
          background: #00ccff;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/mobile/NewsLyt.vue